export default "__VITE_ASSET__C1YwFxFG__"